import { getContext } from '@fiverr-private/fiverr_context';
import { BUSINESS_TRIGGER_CTA, CtaData } from '../types';
import { FIB_SUCCESS_REGISTRATION_URL_FLAG, CTA_DATA_FLAG } from './SuccessModalState';

const LISTINGS_PAGE_PREFIX = '/search';
const VERTICAL_PAGE_PREFIX = '/categories';
const VERTICAL_PAGE_REGEX = new RegExp('^\\/categories\\/[a-z]+[^\\/]*$');
const CONTENT_PAGES_UNDER_CATEGORIES = ['/categories/consulting-services', '/categories/ai-services'];

export const buildRedirectQueryParameters = (data: {
    redirectUrl?: string;
    source?: string;
    type?: BUSINESS_TRIGGER_CTA;
    ctaData?: CtaData;
    balanceInUsdCents?: number;
}) => {
    const { url: contextUrl, queryParameters } = getContext();
    const { balanceInUsdCents = 0, redirectUrl } = data;
    const { pathname, search } = contextUrl ? new URL(contextUrl) : window.location;
    const url = redirectUrl
        ? new URL(redirectUrl, window.location.origin)
        : new URL(pathname + search, window.location.origin);
    const isListingsPage =
        (!!queryParameters.query && pathname.startsWith(LISTINGS_PAGE_PREFIX)) ||
        // sub-categories pages which are rendered via search_perseus
        (pathname.startsWith(VERTICAL_PAGE_PREFIX) && !VERTICAL_PAGE_REGEX.test(pathname));
    const isVerticalPage = VERTICAL_PAGE_REGEX.test(pathname) && !CONTENT_PAGES_UNDER_CATEGORIES.includes(pathname);

    url.searchParams.set(FIB_SUCCESS_REGISTRATION_URL_FLAG, data.type || 'true');

    if (data.source) {
        url.searchParams.set('source', data.source);
    }

    if (data.ctaData && typeof data.ctaData === 'object') {
        url.searchParams.set(CTA_DATA_FLAG, JSON.stringify(data.ctaData));
    }

    if (balanceInUsdCents > 0 && (isListingsPage || isVerticalPage)) {
        url.searchParams.set('welcome_modal', 'migrated_balanced');
    }

    return url.toString();
};
